const SOFTWARE_CODES = ["1039", "1038", "1040", "1043", "1036"]

export default SOFTWARE_CODES
